module.exports = __webpack_public_path__ + "assets/img/img-3.ea051c4d.png";